// Libraries
import { useQuery } from '@tanstack/react-query';

// Hooks
import { useUserId } from './useUserId';

export const useWFMAccessControls = ( accessControlId: string ): boolean => {
    const userId = useUserId();

    const { data } = useQuery( {
        queryKey: [ 'access-controls', userId, accessControlId ]
        , queryFn: () => {
            return fetch( `/api/wfm/access-controls/${ userId }?accessControlId=${ accessControlId }` )
                .then( response => response.json() );
        }
        , enabled: true
    } );

    return JSON.parse( data ?? 'false' );
};
